<template>
  <div class="com-product-pc">
    <img class="bg" :src="dnbk" alt="">
    <img class="img" :src="img" alt="">
  </div>
</template>

<script>
  /**
   * @Class: components
   * @Module: com-product-pc
   * @Description: 组件 -产品 -PC端
   * @Version: 1.0.0
   ---- Created by "Sitdown.liu<731225377@qq.com>" on "2020/4/28 20:19" ---*/
  import dnbk from '@/assets/img/content/dnbk.png';

  export default {
    props: ["img"],
    name: "com-product-pc",
    data() {
      return {
        dnbk
      }
    },
  }
</script>

<style lang="less">
  .com-product-pc {
    width: 100%;
    height: 280px;
    position: relative;

    .bg {
      width: 100%;
      height: 100%;
    }

    .img {
      width: 82%;
      height: 60%;
      position: absolute;
      top: 13%;
      left: 9%;
      border: 1px solid #dddddd;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/com-product-pc.vue